import { environment } from '@environments/environment';
import { RegionAvailable } from '@shared/services/language/registry';

export const envConfiguredNetworkId = (region: RegionAvailable) => environment.domains[region].networkId ?? 0;
